export default "__VITE_ASSET__d70fd801__"